/* eslint-disable */
// WARNING: This file is generated during build from Gen 2 outputs and amplify/runtime-config.json.

const awsmobile = {
  "aws_project_region": "eu-west-2",
  "aws_cognito_identity_pool_id": "eu-west-2:49240e94-c4d5-4b54-80ca-c3b9da49d8e8",
  "aws_cognito_region": "eu-west-2",
  "aws_user_pools_id": "eu-west-2_jnsf5pY4d",
  "aws_user_pools_web_client_id": "7g22uj7d7iafblan4eqn49gd3q",
  "oauth": {},
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "GIVEN_NAME",
    "FAMILY_NAME",
    "EMAIL",
    "PHONE_NUMBER"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "meadocumentsbuckete9dbbc-qbeprod",
  "aws_user_files_s3_bucket_region": "eu-west-2"
};

export default awsmobile;
